export class VehicleModel {
    IdVehicle: number = 0;
    IdVehicleStatus: number = 1;
    VehicleStatus: string = "";
    Manufacturer: string = "";
    Name: string = "";
    Model: string = "";
    SaleValue: number = 0;
    CostPrice: number = 0;
    Year: string = "";
    Km: string = "";
    Gearbox: string = "";
    Fuel: string = "";
    Color: string = "";
    LicensePlate: string = "";
    Observations: string = "";
    Feature: boolean = false;
    FeatureLabel: string = "";
    FeatureImage: string = "";
    CreationDate: Date = new Date();
};

export class VehicleImageModel {
    IdVehicleImage: number = 0;
    IdVehicle: number = 0;
    ImageURL: string = "";
};